module.exports = __webpack_public_path__ + "0f0f1bb12d26c1b9f26a74c0eb4a7628.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-21.png
// module id = 1602
// module chunks = 0